import React, { useState, useEffect } from 'react';
import { Form, Input, InputGroup, Button } from 'reactstrap';
import { toast } from 'react-toastify';
import {Link, useHistory} from 'react-router-dom';
import { connect } from 'react-redux';
import { login } from 'redux/modules/auth/action';
import {logout} from 'redux/modules/auth/action';
import SpinnerButton from 'components/SpinnerButton/SpinnerSubmitButton';

const SignInPage = (props) => {
    let history = useHistory();

    const [login, setLogin] = useState('');
    const [validLogin, checkValidation] = useState(null);
    const [password, setPassword] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if(props.auth && props.auth.isAuthenticated) {
            props.logout();
            history.push('/signin')
        }
    }, [])

    const validation = (value, type) => {
        if (value.split('')[0] === ' ' || value.split('')[value.length - 1] === ' ') {
            return false;
        }

        if (type === 'email') {
            setLogin(value);

            const emailRegExp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            const result = emailRegExp.test(value);

            if (result) {
                checkValidation(1);
            } else {
                checkValidation(2);
            }
        } else {
            setPassword(value);
        }
    };

    const handleSubmit = async(e) => {
        e.preventDefault();
        try {
            setSubmitting(true);
            setError(null);
            await props.login(login, password);

            history.push('/');
        } catch(err) {
            setSubmitting(false);
            console.log(err)
            if(err.code && (err.code === "USERNAME_INVALID" || err.code === "PASSWORD_INVALID")) {
                setError(true)
            } else {
                if(err.message && err.message.length < 150) {
                    toast.error(err.message);
                }
            }
            throw e.message;
        }
    };

    if(props.auth && props.auth.isAuthenticated) return null;
    return (
        <div className="d-flex flex-column justify-content-center align-items-center" style={{/* height: 'calc(100vh - 95px)',*/ width: '100%' }}>
            <div className="d-flex flex-column authorization-container">
                <h3 className="align-self-center mb-2" style={{ fontWeight: '700', fontFamily: 'Sans-serif' }}>
                    Sign In
                </h3>
                <p className="align-self-center mb-2">Enter your login details</p>
                {error && <p style={{marginTop: '-.2rem'}} className="error-text align-self-center mb-3">Email or password is invalid</p>}
                <form onSubmit={handleSubmit}>
                    <InputGroup className="mb-2">
                        <div className="input-group-prepend">
                            <span style={{ width: '40px' }} className="input-group-text" id="basic-addon1">
                                <i className="fas fa-at" />
                            </span>
                        </div>
                        <Input type="email" placeholder="E-mail" value={login} onChange={(e) => validation(e.target.value, 'email')} />
                    </InputGroup>
                    <InputGroup>
                        <div className="input-group">
                            <div className="input-group-prepend">
                                <span style={{ width: '40px' }} className="input-group-text" id="basic-addon1">
                                    <i className="fas fa-unlock-alt"/>
                                </span>
                            </div>
                            <Input
                                type="password"
                                placeholder="Password"
                                onChange={(e) => validation(e.target.value, 'password')}
                                value={password}
                                className="form-control"
                                aria-describedby="basic-addon1"
                            />
                        </div>
                    </InputGroup>
                    <div className="mb-3">
                        <Link to="/reset" style={{ width: '150px', textDecoration: 'underline' }}>
                            Forgot password?
                        </Link>
                    </div>
                    <div className="d-flex flex-column align-self-start">
                        {/*{loading ? (*/}
                        {/*    <Button*/}
                        {/*        style={{ color: 'white', fontWeight: '700' }}*/}
                        {/*        value="Login"*/}
                        {/*        onClick={() => {}}*/}
                        {/*        className="btn calltoaction-button d-flex justify-content-center"*/}
                        {/*    >*/}
                        {/*        <i className="fa fa-spinner fa-spin" />*/}
                        {/*    </Button>*/}
                        {/*) : (*/}
                        {/*    <Input*/}
                        {/*        disabled={validLogin === null || validLogin === 2 || password.length < 6}*/}
                        {/*        style={{ color: 'white', fontWeight: '700' }}*/}
                        {/*        type="Submit"*/}
                        {/*        value="Login"*/}
                        {/*        className="btn calltoaction-button"*/}
                        {/*    />*/}
                        {/*)}*/}
                        <SpinnerButton
                            // onClick={handleSubmit}
                            title="Login"
                            submitting={submitting}
                            block
                        />

                        <div className="mt-2">
                            Don't have an account? <Link to="/signup" style={{ textDecoration: 'underline' }}>Sign up</Link>
                        </div>
                        {/*window.innerWidth < 660 && (
                            <div className="mt-2 d-flex justify-content-center">
                                Don't have an account yet?
                                <Link
                                    to="/sign_up"
                                    style={{
                                        marginLeft: 5,
                                        textDecoration: 'underline',
                                    }}
                                >
                                    Sign up
                                </Link>
                            </div>
                        )*/}
                    </div>
                </form>
            </div>
        </div>
    );
};


const mapStateFromProps = (state) => ({
    auth: state.auth,
});

export default connect(
    mapStateFromProps,
    { login, logout }
)(SignInPage);
